import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Button from '../buttons/Button'
import CloseIcon from '../icons/CloseIcon'

type PopupWindowProps = {
  children: React.ReactNode
  selectedCloseTime?: number
}

// ポップアップウィンドウ（自動）
export const PopupWindow: React.FC<PopupWindowProps> = ({
  children,
  selectedCloseTime,
}) => {
  const [isActive, setIsActive] = useState(true)

  const closeToast = (): void => {
    setIsActive(!isActive)
  }
  // --- import先で 削除時間 を選択できる
  // --- import先で特に指定されていない場合は 60秒後 に削除
  useEffect(() => {
    const timeout = setTimeout(
      () => {
        setIsActive(!isActive)
      },
      selectedCloseTime === undefined ? 60000 : selectedCloseTime
    )
    return (): void => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      {isActive && (
        <PopupWindowWrap>
          <StyledButton onClick={closeToast}>
            <CloseIcon color="var(--color-text-for-main-background)" />
          </StyledButton>
          {children}
        </PopupWindowWrap>
      )}
    </>
  )
}

const PopupWindowWrap = styled.div`
  width: 80%;
  height: 180px;
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #a54646;
  box-sizing: border-box;
  padding-left: calc(100vw / 15);
  border-radius: 3px;
`
const StyledButton = styled(Button)`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 15px;
  right: 15px;
`
